import { render, staticRenderFns } from "./ClosedWaveSection.vue?vue&type=template&id=3dcae407&"
import script from "./ClosedWaveSection.vue?vue&type=script&lang=js&"
export * from "./ClosedWaveSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports